<template>
    <modal size="md" class="ConnectInstagramModal" @close="close">
        <div class="text-center">
            <h3>Forbind instagram</h3>

            <form @submit.prevent="connect">
                <div class="m-xl">
                    <form-item field="instagram_id" :form="form" class="form-group-lg">
                        <label class="control-label">Instagram brugernavn</label>
                        <input
                            v-model="form.instagram_id"
                            type="text"
                            class="form-control input-lg"
                            autofocus
                            placeholder="Fx 'betterhypeapp'"
                        />
                    </form-item>
                </div>
                <button type="submit" class="btn btn-xl btn-success btn-load" :disabled="form.busy">
                    Forbind nu
                </button>
            </form>
        </div>
    </modal>
</template>
<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.ConnectInstagramModal {
}
</style>
<script type="text/babel">
export default {
    props: [],

    data() {
        return {
            form: new SparkForm({}),
        }
    },

    methods: {
        connect() {
            Spark.post(route('api.instagram.connect'), this.form).then(() => {
                this.$emit('success')
            })
        },

        close() {
            this.$emit('close')
        },
    },
}
</script>
